import React from 'react';

import styles from './RightSidebar.module.css';

const RightSidebar = props => {
  return <div className={`${styles.sidebar} fw-mb-24 fw-mr-24`}>{props.children}</div>;
};

export default RightSidebar;
